import React from 'react';
import Spinner from 'react-bootstrap/esm/Spinner';
import classnames from 'classnames';

const Loading:React.FC<{className?: string, size?: 'sm' | undefined}> = ({ className, size }) => {
  return (
    <div className={classnames('loading', className)}>
      <div className="mask"></div>
      <div className="spinner-wrap">
        <Spinner className="spinner" animation="border" variant="secondary" size={size} />
      </div>
    </div>
  );
}

export default Loading;